export default "__VITE_ASSET__Duf6XPDd__"